import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import { BotzNav } from './BotzNav';
import { HeaderStarRoll } from './HeaderStarRoll';
import './AppLayout.css';

export function AppLayout() {
  return (
    <div className="gnews-app">
      <header className="gnews-header">
        <HeaderStarRoll />
        <div className="gnews-header-overlay" aria-hidden="true" />
        <div className="gnews-header-inner">
          <div className="gnews-header-left">
            <BotzNav />
          </div>
          <h1 className="gnews-header-title">
            <Link to="/" className="gnews-header-brand">
              <img src="/logo.png" alt="" className="gnews-logo-img" />
              <span className="gnews-header-brand-text">CineBotz</span>
            </Link>
          </h1>
        </div>
      </header>
      <main className="gnews-main">
        <Outlet />
      </main>
      <footer className="gnews-footer">
        <div className="gnews-footer-inner">
          <nav className="gnews-footer-nav" aria-label="Legal">
            <Link to="/privacy" className="gnews-footer-link">Privacy</Link>
            <span className="gnews-footer-sep" aria-hidden>·</span>
            <Link to="/terms" className="gnews-footer-link">Terms</Link>
          </nav>
          <p className="gnews-footer-copy">© {new Date().getFullYear()} CineBotz</p>
        </div>
      </footer>
    </div>
  );
}
